export const FREE_EMAIL_DOMAINS = new Set([
  "gmail.com", "googlemail.com", "yahoo.com", "yahoo.co.uk", "yahoo.fr", "yahoo.de", "yahoo.co.in", "ymail.com", "rocketmail.com",
  "hotmail.com", "hotmail.co.uk", "hotmail.fr", "outlook.com", "outlook.co.uk", "live.com", "live.co.uk", "msn.com",
  "aol.com", "icloud.com", "me.com", "mac.com", "protonmail.com", "proton.me", "pm.me", "mail.com", "gmx.com", "gmx.de", "gmx.net",
  "yandex.com", "yandex.ru", "zoho.com", "fastmail.com", "hey.com", "tutanota.com", "tuta.io", "inbox.com", "mail.ru", "qq.com", "163.com", "126.com",
]);

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isWorkEmail = (email) => {
  const domain = email.trim().toLowerCase().split("@")[1] || "";
  return domain.length > 0 && !FREE_EMAIL_DOMAINS.has(domain);
};

export const requiredError = (v) => ((v || "").trim() ? null : "Required.");

export const emailError = (v) => {
  const e = (v || "").trim();
  if (!e) return "Required.";
  if (!EMAIL_RE.test(e)) return "Please enter a valid email address.";
  if (!isWorkEmail(e)) return "Please use a work email address.";
  return null;
};
